<div
  class="side-panel-container display-flex flex-column justify-content-center"
  [ngClass]="isSidePanelExpanded ? '' : 'hide-panel'"
>
  <app-animation
    tabindex="0"
    class="cursor-pointer"
    (click)="menuAction(MainPageActions.HOME_PAGE)"
    (keydown.enter)="menuAction(MainPageActions.HOME_PAGE)"
    [attrWidth]="'120px'"
    [attrHeight]="'120px'"
    [loop]="false"
    [animationItem]="Animation.BLACK_LOGO"
  ></app-animation>

  <div class="sections flex-1">
    <app-side-panel-section
      *ngFor="let section of menuConfig"
      [section]="section"
      [currentSectionBSubject]="currentSectionBSubject"
      (menuActionsEvent)="menuAction($event)"
    ></app-side-panel-section>
  </div>
</div>
